<ng-container *ngIf="!isSaving; else loading">
  <h1 mat-dialog-title style="font-size: x-large;">Edit Address</h1>
  <mat-divider></mat-divider>

  <mat-dialog-content>
    <mat-tab-group color="accent" [(selectedIndex)]="tabIndex" backgroundColor="primary">
      <mat-tab label="Mailing Address">
        <form [formGroup]="mailingForm" class="address-form">
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Street Number</mat-label>
              <input matInput formControlName="streetNo">
              <mat-error>Required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Street Name</mat-label>
              <input matInput formControlName="streetName">
              <mat-error>Required</mat-error>
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Street Type</mat-label>
              <input matInput formControlName="streetType">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>City</mat-label>
              <input matInput formControlName="city">
              <mat-error>Required</mat-error>
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>State</mat-label>
              <input matInput maxlength="2" formControlName="state">
              <mat-error>2 letter state</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Zip</mat-label>
              <input matInput formControlName="zip">
              <mat-error>Numeric ZIP</mat-error>
            </mat-form-field>
          </div>

          <div class="actions">
            <button mat-stroked-button (click)="dialogRef.close()">Cancel</button>
            <button mat-raised-button color="primary" [disabled]="mailingForm.invalid" (click)="saveMailing()">
              Save
            </button>
          </div>
        </form>
      </mat-tab>

      <mat-tab label="Service Address">
        <form [formGroup]="serviceForm" class="address-form">
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Street Number</mat-label>
              <input matInput formControlName="streetNo">
              <mat-error>Required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Street Name</mat-label>
              <input matInput formControlName="streetName">
              <mat-error>Required</mat-error>
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Street Type</mat-label>
              <input matInput formControlName="streetType">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>City</mat-label>
              <input matInput formControlName="city">
              <mat-error>Required</mat-error>
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>State</mat-label>
              <input matInput maxlength="2" formControlName="state">
              <mat-error>2 letter state</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Zip</mat-label>
              <input matInput formControlName="zip">
              <mat-error>Numeric ZIP</mat-error>
            </mat-form-field>
          </div>

          <div class="actions">
            <button mat-stroked-button (click)="dialogRef.close()">Cancel</button>
            <button mat-raised-button color="primary" [disabled]="serviceForm.invalid" (click)="saveService()">
              Save
            </button>
          </div>
        </form>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
  
</ng-container>

<ng-template #loading>
  <div class="spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
</ng-template>